import './styles/login.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import { Segment, Form, Dimmer, Loader, Button } from "semantic-ui-react"

import cocacolaExhibit from '../images/Coca-Cola_exhibit-blur.png'

import { loginApiKey, loginAD } from '../redux/actions/auth'

class Login extends React.Component {
  static propTypes = {
    loginApiKey: PropTypes.func.isRequired,
    loginAD: PropTypes.func.isRequired,
    loggingIn: PropTypes.bool.isRequired,
    error: PropTypes.string,
    featureFlags: PropTypes.array.isRequired,
  }

  state = {
    password: '',
  }

  handleNoop = (event) => {
    event.preventDefault()
  }

  handleApiKeyChange = (_, { value }) => {
    this.setState({ password: value })
  }

  handleLoginApiKey = () => {
    const { password } = this.state
    this.props.loginApiKey(password)
  }

  handleLoginWithAD = () => {
    this.props.loginAD()
  }

  render() {
    const { loggingIn, error, featureFlags } = this.props
    const { password } = this.state
    const hasEntraClientId = Boolean(window.config && window.config.entraAuth && window.config.entraAuth.clientId)
    const isLoginADEnabled = featureFlags.includes('enableAzureAdAuth') || hasEntraClientId

    return (
      <React.Fragment>
        <div className="login">
          <div>
            <Segment>
              <React.Fragment>
                {loggingIn && (
                  <Dimmer active>
                    <Loader indeterminate>Logging you in...</Loader>
                  </Dimmer>
                )}
                <Form size="large" autoComplete="off" onSubmit={this.handleFormSubmit}>

                  {error && <div className="login-errors">{error}</div>}
                  <Form.Input
                    readOnly
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    id="password"
                    key="password"
                    name="password"
                    value={password}
                    autoComplete="off"
                    onChange={this.handleApiKeyChange}
                    onFocus={() => {
                      document.getElementById("password").removeAttribute("readOnly");
                    }}
                  />

                  <Button onClick={this.handleLoginApiKey} color="red">
                    {' '}
                    Login{' '}
                  </Button>
                  {isLoginADEnabled && (
                    <Button onClick={this.handleLoginWithAD}>
                      Login with Entra ID
                    </Button>
                  )}
                </Form>
              </React.Fragment>
            </Segment>
          </div>
        </div>

        <div
          className="bg"
          style={{ backgroundImage: `url(${cocacolaExhibit})` }}
        />
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = { loginApiKey, loginAD }
const mapStateToProps = (state) => ({
  loggingIn: state.auth.loggingIn,
  error: state.auth.error,
  featureFlags: state.features.featureFlags,
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
